import React from "react";
import InvalidLink from "./InvalidLink";
const CheckForInvalidLink = (props) => {
  const { valid } = props;

  return (
    <React.Fragment>
      {valid ? props.children : <InvalidLink></InvalidLink>}
    </React.Fragment>
  );
};

export default CheckForInvalidLink;
